import { Route, Routes } from 'react-router-dom';
import HomePage from './Pages/HomePage/HomePage';
import PageNotFound from './Pages/PageNotFound';
import SearchQuestionsPage from './Pages/SearchQuestionsPage/SearchQuestionsPage';
import UserAdmin from './Pages/UserAdmin/UserAdmin';
import GetListPage from './Pages/GetListPage/GetListPage';
import ga4 from 'react-ga4';
import { useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { selectGoogleAnalyticsTrackingId } from './redux/appSettings';
import './App.scss';
import AppContainer from './Pages/AppContainer';
import Redirect from './Pages/Redirect/Redirect';
import TestResults from './Pages/TestResults/TestResults';
import ResultReport from './Pages/ResultReport/ResultReport';
import TestResultsStudent from './Pages/TestResultsStudent/TestResultsStudent';
import DeepLink from './Pages/DeepLink/DeepLink';

function App(): JSX.Element {
  // console.log('app tsx test');
  const googleAnalyticsTrackingId = useSelector(
    selectGoogleAnalyticsTrackingId
  );
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (!ga4.isInitialized && googleAnalyticsTrackingId) {
      ga4.initialize(googleAnalyticsTrackingId);
      // console.log('ga4 initialized', googleAnalyticsTrackingId);
    }
  }, [googleAnalyticsTrackingId]);

  // GA4 is picking up page views automatically, so this is not needed

  useEffect(() => {
    if (!ga4.isInitialized || !googleAnalyticsTrackingId) return;
    // Skip the first render to avoid duplicate with automatic tracking
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    console.debug(
      'sending page view',
      location.pathname + location.search + location.hash
    );
    ga4.send({
      hitType: 'pageview',
      page_path: location.pathname + location.search + location.hash,
      page_search: location.search,
      title: document.title,
    });
  }, [googleAnalyticsTrackingId]);

  return (
    <Routes>
      <Route path="/" element={<AppContainer />}>
        <Route index element={<HomePage />} />
        <Route path=":bookmarkID" element={<HomePage />} />
        <Route path="popquiz" element={<HomePage />} />
        <Route path="testresults" element={<TestResults />} />
        <Route path="testresultsstudent" element={<TestResultsStudent />} />
        <Route path="resultreport" element={<ResultReport />} />
        <Route path="searchquestions" element={<SearchQuestionsPage />} />
        <Route path="userAdmin" element={<UserAdmin />} />
        <Route path="__get_list" element={<GetListPage />} />
        <Route path="*" element={<PageNotFound />} />
      </Route>
      <Route path="/redirect" element={<Redirect />} />
      <Route path="/deepLink" element={<DeepLink />} />
    </Routes>
  );
}

export default App;
